<template>
  <div class="front_wrap">
    <BreadCrumb crumb="网站统计"></BreadCrumb>
    <CountPannel></CountPannel>
    <CurveGraph></CurveGraph>
    <PieGraph></PieGraph>
    <PieGraphOne></PieGraphOne>
  </div>
</template>

<script>
import BreadCrumb from '@/components/widget/BreadCrumb'
import CountPannel from '@/components/widget/CountPannel'
import CurveGraph from '@/components/widget/CurveGraph'
import PieGraph from '@/components/widget/PieGraph'
import PieGraphOne from '@/components/widget/PieGraphOne'
export default {
  name: 'Front',
  data () {
    return {
    }
  },
  components:{
    BreadCrumb,
    CountPannel,
    CurveGraph,
    PieGraph,
    PieGraphOne,
  },
  mounted(){

  },
  methods:{

  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/WebsiteStatistics.vue